import { Stack, Typography } from '@mui/material';
import PaiConfirmDialog from 'features/ui/base-dialogs/pai-confirm-dialog';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;
  loading: boolean;

  handleClose(): void;

  handleCancelLicense(): void;
}

const CancelLicenseDialog: React.FC<Props> = ({ open, loading, handleClose, handleCancelLicense }) => {
  const { classes, cx } = useStyles();
  const { t } = useTranslation();

  return (
    <PaiConfirmDialog
      open={open}
      title={t('cancelSubscription')}
      content={
        <Stack gap={1}>
          <Typography className={classes.text}>{t('cancelSubscriptionWarning1')}</Typography>
          <Typography className={cx(classes.text, 'highlight')}>{t('cancelSubscriptionWarning2')}</Typography>
          <Typography className={classes.text}>{t('cancelSubscriptionWarning3')}</Typography>
        </Stack>
      }
      loading={loading}
      handleClose={handleClose}
      handleConfirm={handleCancelLicense}
    />
  );
};

const useStyles = makeStyles()((theme) => ({
  text: {
    fontSize: theme.typography.pxToRem(15),
    whiteSpace: 'pre-wrap',
    '&.warning': {
      color: theme.palette.warning.main,
      fontWeight: 'bold',
    },
    '&.highlight': {
      color: theme.palette.primary.main,
      fontWeight: 'bold',
    },
  },
}));

export default CancelLicenseDialog;
